"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageEventCode = exports.PageUrls = exports.PageName = exports.LoginLinkNames = exports.EventTypesCodes = void 0;
var analytics_1 = require("@login/analytics");
var StateProvider_1 = require("./StateProvider");
var localdatastore_1 = require("./localdatastore");
var EventTypesCodes;
(function (EventTypesCodes) {
    EventTypesCodes["LINK_CLICK_EVENT"] = "linkClick";
    EventTypesCodes["LINK_CLICK_EVENT_CODE"] = "Link_Click";
    EventTypesCodes["PAGE_LOAD_EVENT"] = "pageLoad";
    EventTypesCodes["PAGE_LOAD_EVENT_CODE"] = "Page_Load";
    EventTypesCodes["FORM_SUBMIT_EVENT"] = "formSubmit";
    EventTypesCodes["FORM_RESPONSE_EVENT"] = "formResponse";
    EventTypesCodes["SYSTEM_EVENT"] = "systemEvent";
})(EventTypesCodes = exports.EventTypesCodes || (exports.EventTypesCodes = {}));
var LoginLinkNames;
(function (LoginLinkNames) {
    LoginLinkNames["COMMON_LOGIN_SUBMIT"] = "Common_Login_Submit";
    LoginLinkNames["FORGOT_PASSWORD"] = "Forgot password?";
    LoginLinkNames["FORGOT_ID"] = "Forgot user ID?";
    LoginLinkNames["REGISTER"] = "Create one now";
    LoginLinkNames["SKIP_AUTHENTICATION"] = "Continue without signing in";
    LoginLinkNames["CANCEL"] = "Continue without signing in";
    LoginLinkNames["Show_Password"] = "Show Password";
    LoginLinkNames["Hide_Password"] = "Hide Password";
    LoginLinkNames["SECURITY_PASSCODE"] = "Learn more about security passcodes";
    LoginLinkNames["FORGOT_PASSCODE"] = "Get a new passcode";
    LoginLinkNames["ACCOUNT_SELECTION"] = "Go back and select a different account";
    LoginLinkNames["SAVEID_CHECK"] = "Save ID";
    LoginLinkNames["UNAUTH_PAYMENTS_CONTNUE_WITHOUT_SIGNING_IN"] = "Just need to make a payment, continue without signing in";
})(LoginLinkNames = exports.LoginLinkNames || (exports.LoginLinkNames = {}));
var PageName;
(function (PageName) {
    PageName["LOGIN_PAGE"] = "Common Login Pg";
    PageName["ACCOUNT_SELECTION"] = "myATT Login Account Selection Pg";
    PageName["NO_WLS_ACCOUNT_PAGE"] = "myATT Login Choose Another ID Pg";
    PageName["PASSCODE_PAGE"] = "myATT Login Enter Passcode Pg";
    PageName["REMOVE_SAVED_ID_MODAL"] = "myATT Login Remove IDs Modal Pg";
    PageName["REMOVE_SAVED_ID_ARE_YOU_SURE_MODAL"] = "myATT Login Remove IDs Confirm Modal Pg";
    PageName["SMB_ACCOUNT_MODAL"] = "myATT Login SMB Passcode Reset Help Modal Pg";
})(PageName = exports.PageName || (exports.PageName = {}));
var PageUrls;
(function (PageUrls) {
    PageUrls["LOGIN_PAGE"] = "/login/authentication";
    PageUrls["ACCOUNT_SELECTION"] = "/login/accountSelection";
    PageUrls["NO_WLS_ACCOUNT_PAGE"] = "/login/needothersignin";
    PageUrls["PASSCODE_PAGE"] = "/login/enterPasscode";
    PageUrls["REMOVE_SAVED_ID_MODAL"] = "/login/authentication/removesavedids";
    PageUrls["REMOVE_SAVED_ID_ARE_YOU_SURE_MODAL"] = "/login/authentication/removeidsconfirmation";
    PageUrls["SMB_ACCOUNT_MODAL"] = "/login/enterpasscode/smbmodal";
})(PageUrls = exports.PageUrls || (exports.PageUrls = {}));
var PageEventCode;
(function (PageEventCode) {
    PageEventCode["LOGIN_PAGE"] = "Common_Login_Submit";
    PageEventCode["ACCOUNT_SELECTION"] = "myATT_LGN_AccountSelection_Submit";
    // NO_WLS_ACCOUNT_PAGE = '/login/needothersignin',
    PageEventCode["PASSCODE_PAGE"] = "myATT_LGN_Passcode_Submit";
})(PageEventCode = exports.PageEventCode || (exports.PageEventCode = {}));
var ReportingService = /** @class */ (function () {
    function ReportingService() {
        this.friendlyPageName = 'page.pageInfo.friendlyPageName';
        this.pageFlowCode = 'page.pageInfo.flowCode';
        this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
    }
    ReportingService.prototype.constructFullUrl = function (path) {
        if (path.includes('http')) {
            return path;
        }
        return window.location.origin + path;
    };
    /**
     * Page Load Event for Each Component
     */
    ReportingService.prototype.analyticsLoginPageLoad = function (cacheParam, pageUrl, pageName) {
        // this.reportingService.firePageLoadEvent('/login/authentication');
        var isPageLoadedAlready = this.checkIfPageLoadEventAlreadyFired(cacheParam);
        if (!isPageLoadedAlready || !isPageLoadedAlready.loaded) {
            this.firePageLoadEvent(pageUrl, pageName);
            this.stateManager.set(cacheParam, { loaded: true });
        }
    };
    ReportingService.prototype.checkIfPageLoadEventAlreadyFired = function (cacheParam) {
        return this.stateManager.get(localdatastore_1.getNamespace('LOGINUI'), cacheParam);
    };
    ReportingService.prototype.firePageLoadEvent = function (urlVal, pageName) {
        if (!this.isSamePage(urlVal)) {
            var flowCode = sessionStorage.getItem('flowCode');
            var appAnalyticsEvent = null;
            if (flowCode) {
                appAnalyticsEvent = {
                    additionaldata: {
                        'page.pageInfo.friendlyPageName': pageName,
                        url: urlVal,
                        'page.pageInfo.flowCode': flowCode,
                    },
                    datatransform: false,
                    eventAction: analytics_1.LoginEventActions.PAGE_LOAD,
                    eventCode: EventTypesCodes.PAGE_LOAD_EVENT_CODE,
                };
            }
            else {
                appAnalyticsEvent = {
                    additionaldata: {
                        friendlyPageName: pageName,
                        url: urlVal,
                    },
                    datatransform: false,
                    eventAction: analytics_1.LoginEventActions.PAGE_LOAD,
                    eventCode: EventTypesCodes.PAGE_LOAD_EVENT_CODE,
                };
            }
            console.log('firePageLoadEvent ', JSON.stringify(appAnalyticsEvent));
            analytics_1.LoginAppSDKManager.reportEvent(appAnalyticsEvent);
        }
    };
    ReportingService.prototype.fireLinkClickEvent = function (linkNameValue, linkUrlValue) {
        // this.firePageLoadEvent(linkUrlValue, );
        var appAnalyticsEvent = {
            additionaldata: {
                linkDestinationUrl: this.constructFullUrl(linkUrlValue),
                linkName: linkNameValue,
                linkPosition: analytics_1.LinkPositionDataKeysOptions.BODY,
            },
            datatransform: false,
            eventAction: analytics_1.LoginEventActions.LINK_CLICK,
            eventCode: EventTypesCodes.LINK_CLICK_EVENT_CODE,
        };
        console.log('fireLinkClickEvent "' + JSON.stringify(appAnalyticsEvent));
        analytics_1.LoginAppSDKManager.reportEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.genericFireFormSubmitEvent = function (page) {
        if (page === 'Account_Selection') {
            this.genericFormSubmitEvent('Continue', PageEventCode.ACCOUNT_SELECTION, PageUrls.ACCOUNT_SELECTION);
        }
        else if (page === 'Passcode') {
            this.genericFormSubmitEvent('Continue', PageEventCode.PASSCODE_PAGE, PageUrls.PASSCODE_PAGE);
        }
    };
    ReportingService.prototype.genericFormSubmitEvent = function (linkNameTxt, eventCodeTxt, PageUrl) {
        var appAnalyticsEvent = {
            additionaldata: {
                errorType: analytics_1.ErrorTypeOption.Success_Admit,
                linkDestinationUrl: this.constructFullUrl(PageUrl),
                linkName: linkNameTxt,
                linkPosition: analytics_1.LinkPositionDataKeysOptions.BODY,
            },
            datatransform: false,
            eventAction: analytics_1.LoginEventActions.FORM_SUBMIT,
            eventCode: eventCodeTxt,
        };
        console.log('genericFormSubmitEvent' + JSON.stringify(appAnalyticsEvent));
        analytics_1.LoginAppSDKManager.reportEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.genericFireFormResponseEvent = function (errorInResponse, errorMsg, errorId, failureType, linkNameTxt, eventCodeTxt, pageUrl) {
        var finalErrorCode = '0';
        var finalErrortype = analytics_1.ErrorTypeOption.Success_Admit;
        var finalStatusMessage = 'success';
        var finalSuccessFlag = analytics_1.SuccessFlags.SUCCESSFUL;
        if (errorInResponse) {
            finalErrorCode = '1';
            finalErrortype = failureType;
            finalStatusMessage = errorMsg;
            finalSuccessFlag = analytics_1.SuccessFlags.UNSUCCESSFUL;
        }
        var appAnalyticsEvent = {
            additionaldata: {
                errorType: finalErrortype,
                linkDestinationUrl: this.constructFullUrl(pageUrl),
                linkName: linkNameTxt,
                linkPosition: analytics_1.LinkPositionDataKeysOptions.BODY,
                statusCode: finalErrorCode,
                statusMessage: finalStatusMessage,
                successFlag: finalSuccessFlag,
            },
            datatransform: false,
            eventAction: analytics_1.LoginEventActions.FORM_RESPONSE,
            eventCode: eventCodeTxt,
        };
        console.log('genericFireFormResponseEvent "' + JSON.stringify(appAnalyticsEvent));
        analytics_1.LoginAppSDKManager.reportEvent(appAnalyticsEvent);
    };
    /*this.reportingService.fireLoginUIFormResponseEvent(false, 'success', '0',
                                                ErrorTypeOption.Success_Admit, 'Sign in', 'Common_Login_Submit');
    */
    ReportingService.prototype.fireLoginUIFormResponseEvent = function (errorInResponse, errorMsg, errorId, failureType, linkNameTxt, eventCodeTxt, pageUrl, saveId) {
        var showPasswordCount = Object.create(StateProvider_1.StateProvider.getStateManagerInstance().get('LOGINUI', 'showPasswordCount'));
        var hidePasswordCount = Object.create(StateProvider_1.StateProvider.getStateManagerInstance().get('LOGINUI', 'hidePasswordCount'));
        var saveIDValue = 0;
        if (saveId) {
            saveIDValue = 1;
        }
        var finalErrorCode = '0';
        var finalErrortype = analytics_1.ErrorTypeOption.Success_Admit;
        var finalStatusMessage = 'success';
        var finalSuccessFlag = analytics_1.SuccessFlags.SUCCESSFUL;
        var pageUrlPassed = pageUrl == null ? pageUrl : PageUrls.LOGIN_PAGE;
        if (errorInResponse) {
            finalErrorCode = '1';
            finalErrortype = failureType;
            finalStatusMessage = errorMsg;
            finalSuccessFlag = analytics_1.SuccessFlags.UNSUCCESSFUL;
        }
        var appAnalyticsEvent = {
            additionaldata: {
                errorType: finalErrortype,
                hidePasswordCount: hidePasswordCount.hidePasswordCount,
                linkDestinationUrl: this.constructFullUrl(pageUrlPassed),
                linkName: linkNameTxt,
                linkPosition: analytics_1.LinkPositionDataKeysOptions.BODY,
                showPasswordCount: showPasswordCount.showPasswordCount,
                statusCode: finalErrorCode,
                statusMessage: finalStatusMessage,
                successFlag: finalSuccessFlag,
                userIdSavedFlag: saveIDValue,
            },
            datatransform: false,
            eventAction: analytics_1.LoginEventActions.FORM_RESPONSE,
            eventCode: eventCodeTxt,
        };
        console.log('fireLoginUIFormResponseEvent "' + JSON.stringify(appAnalyticsEvent));
        analytics_1.LoginAppSDKManager.reportEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireLoginUIFormSubmitEvent = function (saveId) {
        this.LoginUIFormSubmitEvent('Sign in', PageEventCode.LOGIN_PAGE, saveId);
    };
    ReportingService.prototype.LoginUIFormSubmitEvent = function (linkNameTxt, eventCodeTxt, saveId) {
        var showPasswordCount = Object.create(StateProvider_1.StateProvider.getStateManagerInstance().get('LOGINUI', 'showPasswordCount'));
        var hidePasswordCount = Object.create(StateProvider_1.StateProvider.getStateManagerInstance().get('LOGINUI', 'hidePasswordCount'));
        var saveIDValue = 0;
        if (saveId) {
            saveIDValue = 1;
        }
        var appAnalyticsEvent = {
            additionaldata: {
                errorType: analytics_1.ErrorTypeOption.Success_Admit,
                hidePasswordCount: hidePasswordCount.hidePasswordCount,
                linkDestinationUrl: this.constructFullUrl(document.location.href),
                linkName: linkNameTxt,
                linkPosition: analytics_1.LinkPositionDataKeysOptions.BODY,
                showPasswordCount: showPasswordCount.showPasswordCount,
                //  statusCode: '0',
                //  statusMessage: 'success',
                //  successFlag: SuccessFlags.SUCCESSFUL,
                userIdSavedFlag: saveIDValue,
            },
            datatransform: false,
            eventAction: analytics_1.LoginEventActions.FORM_SUBMIT,
            eventCode: eventCodeTxt,
        };
        console.log('LoginUIFormSubmitEvent' + JSON.stringify(appAnalyticsEvent));
        analytics_1.LoginAppSDKManager.reportEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.isSamePage = function (url) {
        var pageInfo = this.stateManager.get('LOGINUI', 'CurrentPageURL');
        if (pageInfo && pageInfo.name && pageInfo.name === url) {
            return true;
        }
        else {
            this.stateManager.set('CurrentPageURL', { name: url });
            return false;
        }
    };
    return ReportingService;
}());
exports.default = ReportingService;
//# sourceMappingURL=ReportingService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/api/ReportingService.js
// module id = 44
// module chunks = 8